import * as React from 'react';

import EntityTab, { IEntityTabProps } from './EntityTab/EntityTab';
import { Tabs, withStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';

import EntityTabContent from './EntityTabContent/EntityTabContent';
import { useLocation } from 'react-router-dom';

export interface IEntityTabsProps {
	tabs: {
		header: IEntityTabProps;
		content: React.ReactNode;
	}[];
}

export default function EntityTabs(props: IEntityTabsProps) {
	const [tabIndex, setTabIndex] = useState(0);
	const location = useLocation();

	useEffect(() => {
		const queryParams = location.search;

		if (queryParams) {
			const tab = parseInt(queryParams.substring(queryParams.indexOf('=') + 1));

			if (!Number.isNaN(tab)) {
				setTabIndex(tab);
			} else {
				setTabIndex(0);
			}
		} else {
			setTabIndex(0);
		}
	}, [location, setTabIndex]);

	const CustomTabs = withStyles({
		root: {
			color: 'black',
			minHeight: '50px',
		},
		indicator: {
			display: 'none',
		},
	})(Tabs);

	const handleChange = (event: React.ChangeEvent<{}>, newIndex: number) => {
		event.preventDefault();
		setTabIndex(newIndex);
		window.history.replaceState(null, document.title, `${location.pathname}?tab=${newIndex}`);
	};

	const tabs = props.tabs.filter((tab) => tab.header.visible);

	return (
		<>
			<CustomTabs variant='fullWidth' value={tabIndex} onChange={handleChange}>
				{tabs.map((tab, i) => (
					<EntityTab key={i} {...tab.header} />
				))}
			</CustomTabs>
			{tabs.map((tab, i) => (
				<EntityTabContent key={i} index={i} value={tabIndex}>
					{tab.content}
				</EntityTabContent>
			))}
		</>
	);
}
